/**
 * Feel constants shared by all mowers. Tuned during the prototype playtest (lm-752.9).
 */

/**
 * How many tile centers a buffered steering request survives while it cannot apply (target tile
 * blocked, or the mower's turn rule says not yet). Lets players swipe a little early, Pac-Man
 * style, without a stale swipe firing much later.
 */
export const INTENT_BUFFER_CENTERS = 2;

/**
 * A request arriving within this many ticks after leaving a tile center still turns at that
 * center (the mower snaps back). Capped at a quarter tile so the snap is never visible.
 */
export const TURN_GRACE_MAX_TICKS = 4;

/**
 * Turn grace at an obstacle (owner, 2026-10-06: a tree's trunk is small, so its tile looks like it
 * leaves more room than it does). Reaching a center with the way ahead blocked, the mower noses on
 * for this fraction of a tile before it crashes; a turn swiped in that time snaps it back to the
 * center and turns it there instead.
 */
export const BRINK_GRACE = { num: 1, den: 3 } as const;

/**
 * Sprinkler timing, in ticks: each head runs a cycle of this period, spraying for `on` ticks of it
 * (offset per head by its position, so a lawn's sprinklers don't pulse in unison). Its renderer
 * warns `warn` ticks before it starts.
 */
export const SPRINKLER = { period: 300, on: 120, warn: 40 } as const;

/** Invulnerability after a survivable crash. */
export const CRASH_INVULN_TICKS = 45;
